import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=b3c5cf30&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3c5cf30')) {
      api.createRecord('b3c5cf30', component.options)
    } else {
      api.reload('b3c5cf30', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=b3c5cf30&", function () {
      api.rerender('b3c5cf30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/Home.vue"
export default component.exports